import React from 'react';
export function FormPageShimmer() {
  return <div className="space-y-6 animate-pulse" role="status" aria-busy="true" aria-live="polite" data-id="element-15094">
      <span className="sr-only" data-id="element-15095">Loading form…</span>
      {/* Header */}
      <div className="flex items-center justify-between" data-id="element-15096">
        <div className="h-6 w-48 bg-gray-200 rounded" data-id="element-15097" />
        <div className="flex gap-2" data-id="element-15098">
          <div className="h-10 w-24 bg-gray-200 rounded-md" data-id="element-15099" />
          <div className="h-10 w-24 bg-gray-200 rounded-md" data-id="element-15100" />
        </div>
      </div>
      {/* Form card */}
      <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-15101">
        <div className="space-y-6" data-id="element-15102">
          {/* Form sections */}
          {[1, 2].map(section => <div key={section} className="space-y-4" data-id="element-15103">
              <div className="h-5 w-32 bg-gray-200 rounded mb-4" data-id="element-15104" />
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-15105">
                {[1, 2, 3, 4].map(i => <div key={i} data-id="element-15106">
                    <div className="h-4 w-24 bg-gray-200 rounded mb-2" data-id="element-15107" />
                    <div className="h-10 w-full bg-gray-200 rounded-md" data-id="element-15108" />
                  </div>)}
              </div>
            </div>)}
          {/* Text area */}
          <div data-id="element-15109">
            <div className="h-4 w-24 bg-gray-200 rounded mb-2" data-id="element-15110" />
            <div className="h-32 w-full bg-gray-200 rounded-md" data-id="element-15111" />
          </div>
          {/* Action buttons */}
          <div className="flex justify-end gap-2 pt-4 border-t border-gray-200" data-id="element-15112">
            <div className="h-10 w-24 bg-gray-200 rounded-md" data-id="element-15113" />
            <div className="h-10 w-32 bg-gray-200 rounded-md" data-id="element-15114" />
          </div>
        </div>
      </div>
    </div>;
}